// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__36Fyn","content":"styles_content__1gWkw","checkbox":"styles_checkbox__3tgOq","checkboxLabel":"styles_checkboxLabel__NQzvq"};